/**
 * Destroy fetch interceptor and clean up.
 *
 * @since 1.0.0
 */

import { clearInterceptedData } from '../get-intercepted-data';
import { getCallbacks, getInterceptedFetch, getOriginalFetch } from '../init-fetch-interceptor';
import type { DestroyOptions } from './types';

/**
 * Destroy fetch interceptor and clean up.
 *
 * @since 1.0.0
 *
 * @param options - Optional cleanup options.
 */
export const destroyFetchInterceptor = (options: DestroyOptions = {}): void => {
  const { clearCallbacks = true, restoreOriginal = true, clearStoredData = true } = options;

  if (restoreOriginal) {
    const originalFetch = getOriginalFetch();
    const interceptedFetch = getInterceptedFetch();

    if (window.fetch === interceptedFetch) {
      window.fetch = originalFetch;
    }
  }

  if (clearCallbacks) {
    const callbacks = getCallbacks();
    callbacks.clear();
  }

  if (clearStoredData) {
    clearInterceptedData();
  }
};
